<template>
  <v-navigation-drawer
    app
    temporary
    hide-overlay
    v-model="localDrawer"
    class="navigation-drawer-left"
  >
    <!-- <div class="ma-2">
          <v-btn @click="onLoadMore()">Load More</v-btn>
        </div>-->
    <v-card elevation="0" class="full-width pa-0 ma-0 body-2 fixed-card">
      <!-- Header -->
      <div class="grey--text text--darken-2 d-flex flex-column pt-3">
        <p
          class="subtitle-1 font-weight-bold d-flex justify-center"
          style="line-height: 0.5"
        >
          OAP2021 Applicants
        </p>
        <p class="subtitle-2 d-flex justify-center" style="line-height: 0.5">
          Total Applicants: {{ totalList }}
        </p>
      </div>
      <v-tabs
        background-color="transparent"
        color="primary"
        class=" d-flex justify-center drawer-tabs"
        v-model="tabForNav"
      >
        <v-tab
          :disabled="!displayFilter"
          v-for="(item, index) in wholeApplicants"
          :key="index"
          @click="onClickApplicantTab(item.title)"
          >{{ item.title }}</v-tab
        >
      </v-tabs>
      <div class="mt-4 mx-4 my-0">
        <v-text-field
          v-model="search"
          placeholder="Search by name, occupation..."
          clear-icon="mdi-close-circle-outline"
          v-on:input="searchApplicants()"
        >
          <v-icon slot="append">mdi-magnify</v-icon>
        </v-text-field>
      </div>
    </v-card>

    <v-divider></v-divider>
    <v-list-item-group class="applicant-list-group" v-model="applicant">
      <div v-if="!applicantsListLoading">
        <v-list-item
          v-for="(applicant, index) in filteredApplicantsList === null
            ? displayedApplicants
            : filteredApplicantsList"
          @click="setApplicantDetails(applicant)"
          :key="index"
          :class="index % 2 == 0 ? 'grey lighten-5' : ''"
        >
          <v-list-item-avatar v-if="applicant.photo">
            <v-img :src="applicant.photo.url"></v-img>
          </v-list-item-avatar>

          <v-list-item-content>
            <div class="d-flex justify-space-between">
              <div class="d-flex align-center justify-center ma-0 pa-0">
                <p style="word-break: break-word;" class="ma-0 pa-0">
                  {{ applicant.name }}
                </p>
              </div>
              <div class="d-flex align-center">
                <span
                  v-if="
                    !applicant.specificSelectorRating ||
                      applicant.specificSelectorRating === undefined
                  "
                ></span>
                <span
                  v-else
                  class="d-flex align-center justify-center font-weight-medium rating-tag primary white--text"
                  >{{ applicant.specificSelectorRating.overallRating }}</span
                >
              </div>
            </div>
          </v-list-item-content>
        </v-list-item>
      </div>
      <div v-else class="d-flex justify-center mt-12 pt-12">
        <v-progress-circular
          indeterminate
          size="60"
          color="accent"
        ></v-progress-circular>
      </div>
    </v-list-item-group>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: 'Sidebar',
  props: {
    totalList: {
      type: Number,
      required: true,
    },
    wholeApplicants: {
      type: Array,
      required: true,
    },
    applicantsListLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
    filteredApplicantsList: {
      type: Array,
      required: true,
    },
    displayedApplicants: {
      type: Array,
      required: true,
    },
    value: {
      type: Boolean,
    },
    displayFilter: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      //   drawer: true,
      tabForNav: false,
      search: null,
      applicant: null,
      localDrawer: false,
    };
  },
  methods: {
    onClickApplicantTab(title) {
      this.$emit('onClickApplicantTab', title);
    },
    searchApplicants() {
      this.$emit('searchApplicants', this.search);
    },
    setApplicantDetails(applicant) {
      this.$emit('setApplicantDetails', applicant);
    },
  },
  watch: {
    value: {
      handler() {
        this.localDrawer = this.value;
      },
    },
    localDrawer: {
      handler() {
        this.$emit('input', this.localDrawer);
      },
    },
  },
};
</script>

<style scoped>
.navigation-drawer-left {
  /* background: red; */
  margin-top: 65px;
  min-width: 300px;
  min-height: 473.8px;
  padding-bottom: 80px;
}

.drawer-tabs {
  box-shadow: 0 0px 0px 0 rgb(252, 251, 251), 0 0 0 7px rgb(255, 255, 255);
}
.fixed-card {
  position: fixed;
  z-index: 1;
  height: 189px;
}
.applicant-list-group {
  /* margin-bottom: 10px;
  background: red; */
  top: 189px;
  border-bottom: 2px rgba(252, 251, 251, 0.664);
}

.rating-tag {
  width: 20px;
  height: 20px;
  border-radius: 20px;
}
</style>
